module.exports = __webpack_public_path__ + "img/restaurant-13.f2cc0185.jpg";